/*
 * Project: forca
 * File Created: Monday, 8th November 2021 1:02:50 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import Accordions from './accordions.component';

export const AccordionsContainer = (props: any) => {
	const containerProps = () => {
		const { currentBlock = null, accordionList } = props;

		if (!currentBlock) {
			return props;
		}

		const { overskrift } = currentBlock;

		const boxes = [];

		if (accordionList.length > 0) {
			accordionList.map(accordion => {
				const item = accordion.currentBlock;
				const { link } = accordion;

				boxes.push({
					headline: item.headline,
					subHeadline: item.subHeadline,
					content: item.content,
					expanded: item.expanded,
					cta: {
						category: item.ctaCategory,
						title: item.ctaLinkTekst,
						url: link,
						target: item.ctaTarget
					}
				});
			});
		}

		return {
			overskrift,
			boxes
		};
	};

	return (
		<Accordions
			{ ...containerProps() }
		/>
	);
};

export default AccordionsContainer;